import { React, useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { GET_POSTBACK_CODE_QUERY } from '../../services/GraphQLQueries'
import '../../layouts/stylesheets/loader-style.css'
import { AiTwotoneSnippets } from 'react-icons/ai'

const PostbackJS = (props) => {
  useEffect(() => {
    const handleNav = (props) => {
      props.setNav('')
      if (props.nav === 'forward') {
        props.setActivePage('source')
      } else if (props.nav === 'back') {
        props.setActivePage('snippet')
      }
    }
    handleNav(props)
  }, [props])

  const [postbackCode, setPostbackCode] = useState('')
  const [postbackType, setPostbackType] = useState('Page')
  const changePostbackType = (e) => {
    setPostbackType(e.target.value)
    if (e.target.value === 'Page') {
      setPostbackCode(data.postbackCode.pagePostback)
    } else {
      setPostbackCode(data.postbackCode.buttonPostback)
    }
  }

  const { data, loading } = useQuery(GET_POSTBACK_CODE_QUERY, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (postbackType === 'Page') {
        setPostbackCode(data.postbackCode.pagePostback)
      } else {
        setPostbackCode(data.postbackCode.buttonPostback)
      }
    },
  })

  const copyCode = async (e) => {
    e.preventDefault()
    navigator.clipboard.writeText(postbackCode)
    let span = document.getElementById('copyMessage')
    span.style.zIndex = 999
    span.style.animation = 'fade 2s forwards'
    setTimeout(() => {
      span.style.animation = ''
      span.style.zIndex = -1
    }, 2000)
  }

  return (
    <>
      {loading ? (
        <>
          <div className="loader-wrapper">
            <div className="flex justify-center items-center">
              <div className="grid gap-10">
                <div className="loader"></div>
                <div className="text-center font-unbounded">Loading...</div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="flex min-h-[calc(100vh-120px)] w-full items-center justify-center bg-white px-6 py-8 sm:px-8 lg:px-10">
          <div className="grid w-full gap-2">
            {/* Small caption */}
            <div className="flex items-center gap-2">
              <p className=" uppercase font-unbounded flex items-center">
                <AiTwotoneSnippets />
                Place a snippet
              </p>
            </div>

            {/* Big title */}
            <h1 className="text-2xl text-onTrack-nightRider font-unbounded">
              Place the M-Tag in your website.
            </h1>

            {/* Subcopy + selector row */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <p className="text-lg leading-snug text-[#0b0b0b]/80">
                Paste this code as high in the &lt;head&gt; of the page as
                possible
              </p>
              <select
                className="w-full md:w-60 p-2.5 text-center bg-white border border-metrinome-border-green text-black text-sm rounded-lg focus:ring-onTrack-light-purple focus:border-onTrack-light-purple"
                value={postbackType}
                onChange={changePostbackType}
              >
                <option value="Page">Thank You Page</option>
                <option value="Button">Confirm Button</option>
              </select>
            </div>

            {/* Code block */}
            <div className="relative rounded-xl bg-metrinome-shadow-green p-4">
              <textarea
                disabled
                id="code-snippet"
                className="w-full h-[28vh] font-mono text-[13px] md:text-[14px] leading-relaxed text-[#0b0b0b] text-left p-2 no-scrollbar resize-none bg-transparent border-0 focus:outline-none"
                value={postbackCode}
              ></textarea>

              {/* Copy control (visually sits at the bottom-right of the code box) */}
              <div className="relative -mt-12 pr-2">
                <span
                  id="copyMessage"
                  className="tooltiptext absolute right-0 -top-10 w-40 text-center"
                >
                  Copied to clipboard
                </span>
                <input
                  type="button"
                  id="copy"
                  onClick={copyCode}
                  className="absolute right-0 -top-8 h-9 px-4 rounded-full bg-white/80 backdrop-blur border border-gray-200 text-gray-800 text-sm font-medium hover:bg-white cursor-pointer"
                  placeholder="Copy the code"
                  value="Copy the code"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PostbackJS
